import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_5 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["hamburger", { '--open': _ctx.isOpen }])
  }, _hoisted_5, 2))
}